import type { Effect, Reducer, Subscription } from "@umijs/max";
import type { SingleAdmRoleType } from "./data";
import {
  addAdmRole,
  editAdmRole,
  getAdmRolePage,
  removeAdmRole,
} from "./service";

export type AdmRoleState = {
  code: number;
  message: string;
  items: SingleAdmRoleType[];
};

type AdmRoleModelType = {
  namespace: string;
  state: AdmRoleState;
  reducers: {
    AdmRoleReducer: Reducer<AdmRoleState>;
  };
  effects: {
    fetchAdmRolePageEffect: Effect;
    refreshDataEffect: Effect;
    addAdmRoleEffect: Effect;
    editAdmRoleEffect: Effect;
    removeAdmRoleEffect: Effect;
  };
  subscriptions: {
    setup: Subscription;
  };
};

// 通用操作处理函数
const createEffect = (serviceCall: any) =>
  function* (
    { payload: action, callback }: any,
    { call, put }: any,
  ): Generator<any, void, any> {
    try {
      const res: any = yield call(
        serviceCall,
        action.values || { id: action.id },
      );

      if (res && res.code === 0) {
        yield put({
          type: "refreshDataEffect",
          payload: { ...action },
        });
      }

      callback?.(res);
    } catch (e) {}
  };

const AdmRoleModel: AdmRoleModelType = {
  namespace: "admRole",
  state: {
    code: 0,
    message: "success",
    items: [],
  },

  reducers: {
    AdmRoleReducer(state, action) {
      const payload = action.payload || {};
      console.log("AdmRoleReducer payload:", payload);

      return {
        ...state,
        ...payload,
        items: payload.data || [],
      } as AdmRoleState;
    },
  },

  effects: {
    *fetchAdmRolePageEffect(
      { payload: { pageSize, current, filter, sorter } }: any,
      { put, call }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(getAdmRolePage, {
          pageSize,
          current,
          filter,
          sorter,
        });
        yield put({
          type: "AdmRoleReducer",
          payload: res,
        });
      } catch (e) {
        console.error("Fetch data failed:", e);
      }
    },

    // 通用刷新数据的 effect
    *refreshDataEffect(
      { payload: action }: any,
      { put, select }: any,
    ): Generator<any, void, any> {
      const current = yield select((state: any) => state.admRole.current);
      const pageSize = yield select((state: any) => state.admRole.pageSize);
      yield put({
        type: "fetchAdmRolePageEffect",
        payload: {
          current,
          pageSize,
          filter: { ...action.filter },
          sorter: action.sorter || [],
        },
      });
    },

    // 简化的 effects
    addAdmRoleEffect: createEffect(addAdmRole),
    editAdmRoleEffect: createEffect(editAdmRole),
    removeAdmRoleEffect: createEffect(removeAdmRole),
  },

  subscriptions: {
    setup() {},
  },
};

export default AdmRoleModel;
